// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"ManageDiscount_pageHolder__lbpC9","MeniPartHolder":"ManageDiscount_MeniPartHolder__2dKc-","MeniPartHolder__EachPart":"ManageDiscount_MeniPartHolder__EachPart__17m2e"};